export default __webpack_public_path__ + "static/media/shopping-cart-p-500.998fa6bf.png";